import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { FormatDurationInSeconds } from "go-core/components/Formatters/FormatDate";
import { ReactComponent as ArrowDownLong } from "../../../../../../../../../../images/svg/bills/arrow-down-long.svg";
import { ReactComponent as ClockSVG } from "../../../../../../../../../../images/svg/bills/clock.svg";
import { preparationStatusColors } from "../../../../../LiveOrders/services/orderStatus";
import { OrderPreviewPreparationStatusName } from "../../services/types";

interface Props {
	preparationStatus: OrderPreviewPreparationStatusName;
	time: string;
	duration?: number;
	lastElement?: boolean;
}

const OrderPreparationStatusesItem = ({ preparationStatus, time, duration, lastElement }: Props) => {
	const { t } = useTranslation();

	const getStatusBackgroundColor = () => {
		switch (preparationStatus) {
			case OrderPreviewPreparationStatusName.NEW:
				return preparationStatusColors.WHITE;
			case OrderPreviewPreparationStatusName.IN_PROGRESS:
			case OrderPreviewPreparationStatusName.ACCEPTED:
				return preparationStatusColors.YELLOW;
			case OrderPreviewPreparationStatusName.READY:
				return preparationStatusColors.GREEN;
			case OrderPreviewPreparationStatusName.PACKED:
				return preparationStatusColors.BLUE;
			case OrderPreviewPreparationStatusName.RECEIVED:
			case OrderPreviewPreparationStatusName.IN_DELIVERY:
				return preparationStatusColors.GRAY;
			case OrderPreviewPreparationStatusName.DELIVERED:
				return preparationStatusColors.PURPLE;
			default:
				return "";
		}
	};

	return (
		<tr>
			<td>
				<div>
					<div
						className={`status ${
							getStatusBackgroundColor() === preparationStatusColors.WHITE ? "empty" : ""
						}`}
						style={{ backgroundColor: getStatusBackgroundColor() }}
					/>
					{!lastElement && <ArrowDownLong className="mt-1" />}
				</div>
			</td>
			<td>
				<div>
					{preparationStatus === OrderPreviewPreparationStatusName.NEW
						? t("enums.preparation_statuses.CREATED")
						: t(`enums.preparation_statuses.${preparationStatus}`)}
				</div>
			</td>
			<td>
				<div className="d-flex align-items-center">
					<ClockSVG className="me-1" />
					<p className="mb-0">{moment(time).format("HH:mm:ss")}</p>
				</div>
			</td>
			<td>
				<div>{duration !== undefined ? FormatDurationInSeconds(duration, t) : ""}</div>
			</td>
		</tr>
	);
};

export default OrderPreparationStatusesItem;

// t("enums.preparation_statuses.ACCEPTED")
// t("enums.preparation_statuses.IN_DELIVERY")
